import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "../chunk-MQXBDTVK.js";

// src/providers/alchemy.ts
function alchemyProvider(_ref) {
  let {
    apiKey
  } = _ref;
  return function (chain) {
    var _chain$rpcUrls$alchem, _chain$rpcUrls$alchem2;
    const baseHttpUrl = (_chain$rpcUrls$alchem = chain.rpcUrls.alchemy) === null || _chain$rpcUrls$alchem === void 0 ? void 0 : _chain$rpcUrls$alchem.http[0];
    const baseWsUrl = (_chain$rpcUrls$alchem2 = chain.rpcUrls.alchemy) === null || _chain$rpcUrls$alchem2 === void 0 || (_chain$rpcUrls$alchem2 = _chain$rpcUrls$alchem2.webSocket) === null || _chain$rpcUrls$alchem2 === void 0 ? void 0 : _chain$rpcUrls$alchem2[0];
    if (!baseHttpUrl) return null;
    return {
      chain: _objectSpread(_objectSpread({}, chain), {}, {
        rpcUrls: _objectSpread(_objectSpread({}, chain.rpcUrls), {}, {
          default: {
            http: ["".concat(baseHttpUrl, "/").concat(apiKey)]
          }
        })
      }),
      rpcUrls: {
        http: ["".concat(baseHttpUrl, "/").concat(apiKey)],
        webSocket: ["".concat(baseWsUrl, "/").concat(apiKey)]
      }
    };
  };
}
export { alchemyProvider };